const getCaption = async (imageId) => {
  const response = await fetch(
    `${window.location.origin}/wp-json/copyright/v1/media/${imageId}`
  );
  if (!response.ok) return false;
  const data = await response.json();
  if (!data.data || !data.success) return false;
  return data.data.copyright;
};
window.addEventListener("DOMContentLoaded", async function () {
  const images = document.querySelectorAll(".wp-block-image img");
  if (!images.length) return;
  // Handles all the images asynchronously at once.
  await Promise.all(
    Array.from(images).map(async (img) => {
      await handleImage(img);
    })
  );
});

const handleImage = async (img) => {
  // We go through all images on the page and add the copyright hover symbol.
  const imgHashId = btoa(img.src, true);
  const imageId = Array.from(img.classList)
    .map(function (className) {
      if (className.startsWith("wp-image-")) {
        return className.replace("wp-image-", "");
      }
    })
    .filter(function (className) {
      return className !== undefined;
    })
    .shift();
  img.setAttribute("data-image-hash", imgHashId);
  // Wrap the image in a div, so we can add the image credit.
  const imgWrapperEl = Object.assign(document.createElement("div"), {
    className: "set-relative",
  });

  // Create the image credit element.
  const imgCreditEl = Object.assign(document.createElement("div"), {
    className: "image-credit",
    innerHTML: `<p class="image-credit-text"><span class="copyright-symbol"><i class="fa-light fa-copyright"></i></span><span class="copyright-text"></span></p>`,
  });
  imgCreditEl.setAttribute("data-image-hash", imgHashId);

  let hasCopyright = false;
  if (img.hasAttribute("data-image-copyright")) {
    imgCreditEl.setAttribute(
      "data-image-copyright",
      img.getAttribute("data-image-copyright")
    );
    hasCopyright = true;
  }
  let copyright;
  if (!hasCopyright) {
    copyright = await getCaption(imageId);
    if (copyright) {
      imgCreditEl.setAttribute("data-image-copyright", copyright);
      hasCopyright = true;
    }
  }

  if (!hasCopyright) {
    return;
  }

  imgCreditEl.querySelector(".image-credit-text .copyright-text").innerText =
    imgCreditEl.getAttribute("data-image-copyright");

  img.parentNode.insertBefore(imgWrapperEl, img);
  imgWrapperEl.appendChild(img);

  imgCreditEl.addEventListener("click", function (ev) {
    const el = ev.currentTarget;
    if (el.classList.contains("hovering") && !el.classList.contains("show")) {
      el.classList.add("force-open");
      return;
    }
    el.classList.toggle("show");
    el.classList.toggle("force-open");
  });

  imgCreditEl.addEventListener("mouseenter", function (ev) {
    const el = ev.currentTarget;
    el.classList.add("show");
  });

  img.addEventListener("mouseenter", function (ev) {
    const el = ev.currentTarget;
    const imgCreditEl = el.parentNode.querySelector(".image-credit");

    imgCreditEl.classList.add("show", "hovering");
  });

  img.addEventListener("mouseleave", function (ev) {
    const el = ev.currentTarget;
    const imgCreditEl = el.parentNode.querySelector(".image-credit");

    if (!imgCreditEl.classList.contains("force-open")) {
      imgCreditEl.classList.remove("show", "hovering");
    }
  });

  img.insertAdjacentElement("afterend", imgCreditEl);
};
